/*
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2023 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import {
    ApiHandler,
    createHandlerChainRunner,
    Handler,
    HasOnError,
    HasOnSuccess,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import { getInterestCategories } from "@pacific/App/Services/SubscribeService";
import {IneterestCategoriesModel} from "@pacific/XDL/types"


type HandlerType = ApiHandler<
    HasOnSuccess<IneterestCategoriesModel> & HasOnError<string>,
    IneterestCategoriesModel
>;

export const RequestDataFromApi: HandlerType = async props => {
    try {
        props.apiResult = await getInterestCategories();
    } catch (error) {
        const failedMessage =
            (error as any)?.errorMessage || "Please try again and contact support if you continue to have issues.";
        props.parameter.onError?.(failedMessage);
        return false;
    }
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    props.parameter.onSuccess?.(props.apiResult);
};

export const chain = [RequestDataFromApi, ExecuteOnSuccessCallback];

const getInterestCategoriesHandler = createHandlerChainRunner(chain, "GetInterestCategoriesHandler");

export default getInterestCategoriesHandler;

